<template>
  <div class="form-group with-icon-left">
    <div class="input-group">
      <input id="input-icon-left" name="input-icon-left" @keyup="doFilter()" v-model="filterText" required/>
      <i class="glyphicon glyphicon-search icon-left input-icon search-icon"></i>
      <label class="control-label" for="input-icon-left">{{label}}</label><i class="bar"></i>
    </div>
    <vuestic-tooltip :options="tooltipOptions"><i class="hint fa fa-question-circle-o"></i></vuestic-tooltip>
  </div>
</template>

<script>
  import store from 'vuex-store'

  export default {
    name: 'filterBar',
    props: {
      label: {
        type: String
      },
      setSaleType: {
        type: Function
      }
    },
    data () {
      return {
        filterText: '',
        typingTimeout: null,
        typingDelay: 250,
        tooltipOptions: {
          content: `
            <h4>Acceptable formats</h4>
            <table>
              <tr>
                <td class="right">ID</td>
                <td>number</td>
              </tr>
              <tr>
                <td class="right">AltOrderID</td>
                <td>string</td>
              </tr>
              <tr>
                <td class="right">Phone</td>
                <td>number</td>
              </tr>
              <tr>
                <td class="right">Customer</td>
                <td>name or surname</td>
              </tr>
              <tr>
                <td class="right">Address v1</td>
                <td>street number</td>
              </tr>
              <tr>
                <td class="right">Address v2</td>
                <td>number street city</td>
              </tr>
            </table>
          `,
          placement: 'bottom'
        }
      }
    },
    methods: {
      doFilter () {
        store.commit('setSaleType', -1) // When searching always default to All tab
        this.typingTimeout && clearTimeout(this.typingTimeout)
        this.typingTimeout = setTimeout(() => this.$emit('filter', this.filterText), this.typingDelay)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-icon {
    transform: rotate(90deg);
  }

  .form-group {
    min-width: 7rem;
  }

  .hint:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    .form-group {
      width: 80%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue